import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as gapiAction from '../../actions/gapiActions'
import queryString from 'query-string';

class GapiIndex extends React.Component {
  constructor(props) {
    super(props)

  }

	componentWillMount() {
        let params = queryString.parse(this.props.location.search)
        console.log("THIS>QUERY", params)
        let bodyData = {
            code : params.code,
            action: 'PUT'
        }
        // console.log('Code: ', this.props.location);
        // var url_parts = url.parse(this.props.location, true);
        // var code = url_parts.query.code;
        // if (code) 
        //     console.log("CODE ", code)
        if (params.code) {
            this.props.gapiAction.putGapiToken(bodyData, this.props);
        }
        // this.props.history.push('/')
        

	}
    render () {
        return (
            <p>
                Wait Till we authenticate you
            </p>
        )
    }
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		gapi: state.gapi,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {

	return {
		gapiAction: bindActionCreators(gapiAction, dispatch),

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(GapiIndex);





